// extracted by mini-css-extract-plugin
export var body = "_32-1";
export var bodyPadded = "_32-2";
export var chevron = "_32-4";
export var chevronOpen = "_32-5";
export var header = "_32-0";
export var icon = "_32-3";